import Rails from "@rails/ujs"
import "../stylesheets/tailwind"
import "../stylesheets/billing"
import "../stylesheets/modal"
import "../src/billing"
import "../src/billing/pricing"
import "../src/botProtection"
import "../src/dataClickStopPropagation"
import "../src/dataClipboardCopy"
import "../src/dataEnable"
import "../src/dataModal"
import "../src/dataToggle"
import "../src/dataTooltip"
import "../src/dropdown"
import "../src/notification"
import "../src/setTimeZone"
import "../src/rangeSlider"

Rails.start()
